import React from 'react';
import './ClearFiltersButton.scss';
import { CloseThin } from '@/resources/assets/images';

interface Props {
	filterCount: number;
	onClick: () => void;
	large?: boolean;
}

const ClearFiltersButton = ({ filterCount, onClick, large }: Props) => {
	const onClickHandler = (e: React.MouseEvent) => {
		e.stopPropagation();
		onClick();
	};

	return (
		<div className={`clear-filters-button ${large ? 'large' : ''}`}>
			<span className="clear-filters-number">{filterCount}</span>
			<span className="clear-filters-button-divider" />
			<button
				className="clear-filters-button-click"
				type="button"
				onClick={onClickHandler}
			>
				<CloseThin className="clear-filters-button-icon" />
			</button>
		</div>
	);
};

export default ClearFiltersButton;
